import { expand } from 'uri-template-lite';
import { apiClient } from '../../common/ApiClient';
import {
  ClassifierMappingsFormDataSchema,
  ClassifierMappingsFormDataType,
} from '../types';
import { createApiQueryHook } from '../../common/queryClient/createApiQueryHook';
import { ClassifierMappingUrl } from './ClassifierMappingUrl';

const getClassifierMapping = (id: number) =>
  apiClient
    .get<ClassifierMappingsFormDataType>(
      expand(ClassifierMappingUrl.CLASSIFIER_MAPPING, { id })
    )
    .then((response) => ClassifierMappingsFormDataSchema.parse(response.data));

export const useGetClassifierMappingQuery = createApiQueryHook(
  ['classifierMapping'],
  getClassifierMapping
);
